import type { AppLayoutHandlers } from './app-layout.hook'
import type { UseAppLayoutActionsReturn } from './use-app-layout-actions.hook'
import type { AppLayoutNavigationHandlers } from './use-app-layout-navigation.hook'
import type { UseAppLayoutOrganizationReturn } from './use-app-layout-organization.hook'
import type { UseAppLayoutSearchReturn } from './use-app-layout-search.hook'

interface BuildAppLayoutHandlersParams {
  search: UseAppLayoutSearchReturn
  organization: UseAppLayoutOrganizationReturn
  navigation: AppLayoutNavigationHandlers
  actions: UseAppLayoutActionsReturn
}

export const buildAppLayoutHandlers = ({
  search,
  organization,
  navigation,
  actions,
}: BuildAppLayoutHandlersParams): AppLayoutHandlers => ({
  handleSignOut: organization.handlers.handleSignOut,
  handleOrganizationSelect: organization.handlers.handleOrganizationSelect,
  handleCreateOrganization: organization.handlers.handleCreateOrganization,
  handleCreateOrgDialogChange: organization.handlers.handleCreateOrgDialogChange,
  handleCreateOrgSubmit: organization.handlers.handleCreateOrgSubmit,
  handleCreateProject: navigation.handleCreateProject,
  handleAgenciesClick: navigation.handleAgenciesClick,
  handleAgenciesSettings: navigation.handleAgenciesSettings,
  handleCreateChat: navigation.handleCreateChat,
  handleConnectsClick: navigation.handleConnectsClick,
  handleOrgSettings: navigation.handleOrgSettings,
  handleGlobalSearch: search.handlers.handleGlobalSearch,
  handleResultSelect: search.handlers.handleResultSelect,
  handleNotificationClick: actions.handlers.handleNotificationClick,
  handleMarkAllRead: actions.handlers.handleMarkAllRead,
})
